import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IJob } from '@interfaces';
import { IPaginationParams } from '../interfaces/IPaginationParamas';
import { ApiResponse } from '@shared';
import { Observable } from 'rxjs';

export type JobListParams = IPaginationParams & {
  // comma-joined multi-selects + a YYYY-MM-DD publish range (08/10/2026)
  statuses?: string;
  specializationIds?: string;
  workAreaIds?: string;
  publishedFrom?: string;
  publishedTo?: string;
};

// back-office section "חיבורים לעבודה" → /v1/admin/jobs
@Injectable({
  providedIn: 'root',
})
export class JobsService {
  constructor(private http: HttpClient) {}

  private toParams(params: JobListParams) {
    let httpParams = new HttpParams();
    Object.keys(params || {}).forEach((key) => {
      const value = (params as any)[key];
      if (key === 'columnFilters' || value === undefined || value === null || value === '') return;
      httpParams = httpParams.append(key, String(value));
    });
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, value?.$regex);
    });
    return httpParams;
  }

  getJobs(params: JobListParams): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/admin/jobs', { params: this.toParams(params) });
  }

  // the section's expiry numbers (Q5): { defaultExpiryDays, maxExpiryDays }
  getSettings(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>('/v1/admin/jobs/settings');
  }

  updateSettings(settings: { defaultExpiryDays: number; maxExpiryDays: number }): Observable<ApiResponse> {
    return this.http.put<ApiResponse>('/v1/admin/jobs/settings', settings);
  }

  getJob(id: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(`/v1/admin/jobs/${id}`);
  }

  createJob(job: IJob): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/v1/admin/jobs', job);
  }

  updateJob(id: string, job: IJob): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/jobs/${id}`, job);
  }

  approveJob(id: string): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/jobs/${id}/approve`, {});
  }

  rejectJob(id: string, rejectionReason: string): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/jobs/${id}/reject`, { rejectionReason });
  }

  closeJob(id: string): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/v1/admin/jobs/${id}/close`, {});
  }

  deleteJob(id: string): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(`/v1/admin/jobs/${id}`);
  }

  // the grid's live params minus paging — the backend's unpaginated() drops paging anyway
  exportJobs(params: JobListParams) {
    return this.http.post<HttpResponse<Blob>>(
      `/v1/admin/jobs/export`,
      {},
      {
        params: this.toParams(params),
        observe: 'response' as 'body',
        responseType: 'blob' as 'json',
      },
    );
  }
}
